export const GENERAL_URLS = {
  privacyPolicy: 'https://docs.magic.store/documents/legal-documents/privacy-policy',
  termsAndConditions:
    'https://docs.magic.store/documents/legal-documents/magic-store-terms-and-conditions',
};
